const STORAGE_KEY = 'empiremaps_broadcast_tour_v1';

export function hasSeenBroadcastTour(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markBroadcastTourSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* private browsing, etc. */
  }
}
